import { getCountries, getPlaceList, getIDTypes, getTaxStatuses, getSettBankList, getModeOfPayments, getSecurityRegistrationOptions } from './orderFormData';

export class OrderFileValidator {

  /* Construct security defaults */
  constructor(security) {
    console.log(security);
    this.denomination = security.denomination.value.primary;
  }

  /*
    Determine applicant name association. Strictly either *AND* or *OR* only
    Returns Null if association not found.
  */
  getAssoc = (string) => {
    if(string.includes('*AND*') && string.includes('*OR*')) {
      throw TypeError;
    } else if (string.includes('*AND*')){
      return '*AND*';
    } else if (string.includes('*OR*')){
      return '*OR*';
    }
    return null;
  }

  /*
    Validate Primary Account Name
  */
 validatePrimaryAccname = (nameCol, category) => {
   if(nameCol.includes(';') && category.includes('INDV')){
      const nameSegment = nameCol.split(';');
      if(nameSegment.length<3 && nameSegment.length !== 1){
        return false
      }
   }
   return true
 }

  /*
    Validate Names in the row; checks for parsing error.
  */
  validateNames = (nameCol, primaryAccname, investorCateg) => {
    if(!primaryAccname.includes(';') || investorCateg === 'CORP'){
      if(nameCol.trim() !== ''){
        return 'Invalid Other Applicants Name. This field should be empty if investor is CORP, QIB or TRUST-FAO';
      }
    }
    if (nameCol === ""){
      return false
    };
    let ASSOC;
    try {
      ASSOC = this.getAssoc(nameCol);
    } catch { return false; }
    var nameItems = nameCol.split(ASSOC);
    nameItems = nameItems.slice(1,nameItems.length);
    for(var idx in nameItems){
      const nSegment = nameItems[idx].split(';');
      if(nSegment[0]){
        if(nSegment[0].trim() === ''){
          return "Invalid Lastname in Other Applicants Column. Field Value: \""+nSegment[0]+"\"";
        }
      } else {
        return "Invalid Other Applicant field. Missing Lastname";
      }
      if(nSegment[1]){
        if(nSegment[1].trim() === ''){
          return "Invalid Firstname in Other Applicants Column.";
        }
      } else {
        return "Invalid Other Applicant field. Missing Firstname";
      }
      if(nSegment[2]){
        if(nSegment[2].trim() === ''){
          return "Invalid Middlename in Other Applicants Column."
        }
      } else {
        return "Invalid Other Applicant field. Missing Middlename.";
      }
      if(nSegment[3]){
        if(!this.validateEmailAddress(nSegment[3].trim())){
          return "Invalid Email in Other Applicants Column."
        }
      } else {
        return "Invalid Other Applicant field. Missing email address."
      }
      if(nSegment[4]){
        if(!this.validateDateFormat(nSegment[4].trim())){
          return "Invalid Birthdate in Other Applicants Column. Birthdate should be (yyyy-mm-dd)"
        }
      } else {
        return "Invalid Other Applicant field. Missing Birthdate."
      }
    }

    return true;
  }

  validatePrimaryContactPersonName = (nameCol) => {
    const nameTest = nameCol.split(';');
    return nameTest.length === 3;
  }

  /*
    List values validator for col that needs selection of values.
  */ 
  validateListValue = (key, value) => {
    value = value.trim();
    switch(key){
      case 'investorCategory':
        return ['INDV', 'CORP'].includes(value)
      case 'placeOfResidence' : 
        return getPlaceList().some(cls => cls.value.trim() === value);
      case 'domicile' : 
        return getCountries().some(cls => cls.value.trim() === value);
      case 'nationality' :
        return getCountries().some(cls => cls.value.trim() === value);
      case 'taxStatus' : 
        return getTaxStatuses().some(cls => cls.value.trim() === value);
      case 'idTypeIndiv' : 
        return getIDTypes('INDV').some(cls => cls.value.trim() === value);
      case 'idTypeCorp' : 
        return getIDTypes('CORP').some(cls => cls.value.trim() === value);
      case 'registrationOfSecurities':
        return getSecurityRegistrationOptions().some(cls => cls.value.trim() === value);
      case 'settBankCode' : 
        return getSettBankList().some(cls => cls.value.trim() === value);
      case 'modeOfCollectionOfInterest' :
        return ['RTGS', 'CREDIT_SAVINGS_ACC_NUM'].some(cls => cls.trim() === value);
      case 'modeOfPayment':
        return getModeOfPayments().some(cls => cls.value.trim() === value);
      case 'statementDeliveryMode':
        return ['E', 'D'].includes(value);
    }
    return false;
  }
    
  /*
    Validate investor purchase amount field.
    Check if string value is numeric and can be parse to intneger/float
  */
  validatePurchaseAmount = (str) => {
    str = str.trim();
    if (typeof str != "string") { return false };
    str = str.replaceAll(',','');
    let denominationFlag = true;
    if(parseFloat(str) < this.denomination.minimum || parseFloat(str) % this.denomination.increments !== 0){
      denominationFlag = false;
    }
    return !isNaN(str) && !isNaN(parseFloat(str)) && denominationFlag;
  }

  /*
    Check if string is empty or containns only whitespaces
  */
  isEmpty = (strData) => {
    return strData.match(/^ *$/) !== null;
  }

  /*
    Email Address Validator
  */
  validateEmailAddress = (email) => {
    email = email.trim();
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
  }

  /*
    Validate Zipcode.
    Check if character length is less than 6 and matches numeric only pattern
  */
  validateZipCode = (zipCode) => {
    zipCode = zipCode.trim();
    return zipCode.length < 6 && /^[0-9]*$/.test(zipCode);
  }

  /*
    Valiate comma delimitted string
    if greater than 0
  */
  validateListNotEmpty = (colValue) => {
    const segments = colValue.split(';');
    return segments[0] != ''
  }

  /*
    Validate bank peso account number.
    Checks for scientific notation strings for numeric values.
  */
  validateAccountNumber = (value) => {
   const regex = /\d+(\.\d*[eE]\+\d+)/;
   if(regex.test(value.trim())){
     return 'Invalid value for account number: '+value;
   }
   if(value.trim() === ''){
     return 'Invalid value for account number: Account number empty.';
   }
   return true;
  }

  /*
    Validate date format
  */
  validateDateFormat = (value) => {
    // Check Date Delimiter
     let dateString = value.replaceAll('/', '-'); // force date delimiter to be dash

    // Validate date format (YYYY-MM-DD)
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    if(!dateString.match(regEx)) return false;  // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0,10) === dateString;
  }

  /*
    Scan Column Data for non utf-8
    special characters
  */
  scanColDataCharacters= (colData) => {
    for(var idx in colData){
      if(/[^\x20-\x7E]+/.test(colData[idx].trim())){
        var char = colData[idx].trim().match(/[^\x20-\x7E]+/)[0];
        return {
          valid: false,
          data: colData[idx],
          idx: idx
        }
      }
    }
    return {
      valid: true,
      data: '',
      idx: 0
    }
  }

  validateIDNumber = (value) => {
    return value.length <= 30
  }

  validateApplicantNoCDBPID = (value) => {
    return !value.trim().endsWith('B') && !value.trim().endsWith('b');
  }

  /*
    Validate File's Data row by row.
    Counter check each columns as order fields
  */
  validateRow = (rowData) => {
    const colData = rowData.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
    const scanRes = this.scanColDataCharacters(colData);
    if(!scanRes.valid){
      return {
        valid: false,
        msg: 'Invalid special character found. '+scanRes.data+' COLUMN '+scanRes.idx
      }
    }
    if(colData === null){
      return {
        valid: true,
        msg: 'OK'
      }
    }
    if(colData.length < 20) {
      return {
        valid: null,
        msg: 'Insufficient data in column.'
      }
    }
    const colFormat = {
      refNumber: {
        isRequired: false,
        validator: null
      },
      emailAddress: {
        isRequired: true,
        validator: this.validateEmailAddress,
        msg: 'Invalid Email Address in column number 2.'
      },
      purchaseAmount: {
        isRequired: true,
        validator: this.validatePurchaseAmount,
        msg: 'Invalid Purchase Amount Value. (Invalid format or denomiation/increment)'
      },
      investorCategory: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('investorCategory', value) },
        msg: 'Invalid Investor Category'
      },
      primaryAccname: {
        isRequired: true,
        validator: (value) => this.validatePrimaryAccname(value, colData[3]),
        msg: 'Invalid Primary Account Name.'
      },
      applicantNames: {
        isRequired: false,
        validator: (value) => { return this.validateNames(value, colData[4], colData[3]) },
        msg: 'Invalid Other Applicant field. Please check the applicant names format.'
      },
      primaryContactPerson: {
        isRequired: false,
        validator: this.validatePrimaryContactPersonName,
        msg: 'Invalid Primary Contact Person Name'
      },
      relationship: {
        isRequired: false,
        validator: null
      },
      nationality: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('nationality', value) },
        msg: 'Invalid Nationality value'
      },
      dateOfBirth: {
        isRequired: true,
        validator: this.validateDateFormat,
        msg: 'Missing/Invalid Date of Birth/Incorporation (yyyy-mm-dd)'
      },
      placeOfBirth: {
        isRequired: true,
        validator: null,
        msg: 'Missing Place of Birth/Incorporation'
      },
      idType: {
        isRequired: true,
        validator: (value) => {
          if(colData[3].trim() === 'CORP'){
            return this.validateListValue('idTypeCorp', value);
          } else {
            return this.validateListValue('idTypeIndiv', value);
          }
        },
        msg: 'Invalid ID Type value'
      },
      idNumber: {
        isRequired: true,
        validator: this.validateIDNumber,
        msg: 'Invalid ID Number'
      },
      taxStatus: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('taxStatus', value) },
        msg: 'Invalid Tax Status value'
      },
      natureOfWork: {
        isRequired: true,
        validator: null,
        msg: 'Missing Nature of Work'
      },
      natureOfEmployer: {
        isRequired: true,
        validator: null,
        msg: 'Missing Nature of Employer'
      },
      parentCompany: {
        isRequired: false,
        validator: null
      },
      sourcesOfIncome: {
        isRequired: true,
        validator: this.validateListNotEmpty,
        msg: 'Incomplete sources of income'
      },
      telephoneNumbers: {
        isRequired: false,
        validator: null
      },
      faxNumbers: {
        isRequired: false,
        validator: null
      },
      statementDeliveryMode: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('statementDeliveryMode', value) },
        msg: 'Invalid Statement Delivery Mode value'
      },
      placeOfResidence: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('placeOfResidence', value) },
        msg: 'Invalid Place of Residence Value'
      },
      addressStreet: {
        isRequired: true,
        validator: null,
        msg: 'Invalid Street Address'
      },
      addressDistrictOrTown: {
        isRequired: true,
        validator: null,
        msg: 'Invalid District Or Town Address'
      },
      addressCity: {
        isRequired: true,
        validator: null,
        msg: 'Invalid City in Address'
      },
      addressStateRegionProvince: {
        isRequired: true,
        validator: null,
        msg: 'Invalid State Region or Province in Address'
      },
      addressCountry: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('domicile', value) },
        msg: 'Invalid domicile (Permanent Address: Country)'
      },
      addressZipCode: {
        isRequired: true,
        validator: this.validateZipCode,
        msg: 'Invalid Zip Code Value'
      },
      presentAddressStreet: {
        isRequired: true,
        validator: null,
        msg: 'Invalid Street Address'
      },
      presentAddressDistrictOrTown: {
        isRequired: true,
        validator: null,
        msg: 'Invalid District Or Town Address'
      },
      presentAddressCity: {
        isRequired: true,
        validator: null,
        msg: 'Invalid City in Address'
      },
      presentAddressStateRegionProvince: {
        isRequired: true,
        validator: null,
        msg: 'Invalid State Region or Province in Address'
      },
      presentAddressCountry: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('domicile', value) },
        msg: 'Invalid domicile (Present Address: Country)'
      },
      presentAddressZipCode: {
        isRequired: true,
        validator: this.validateZipCode,
        msg: 'Invalid Zip Code Value'
      },
      modeOfCollectionOfInterest: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('modeOfCollectionOfInterest', value)},
        msg: 'Invalid Mode of Collection of Interest Value'
      },
      modeOfPayment: {
        isRequired: true,
        validator: value => this.validateListValue('modeOfPayment', value),
        msg: 'Invalid Mode of Payment'
      },
      modeOfPaymentBank: {
        isRequired: ['DIRECT_DEBIT','BANK_CHECK'].includes(colData[35].trim()),
        validator: (value) => { return this.validateListValue('settBankCode', value) },
        msg: 'Invalid Mode Of Payment Bank'
      },
      modeOfPaymentCheckNumber: {
        isRequired: colData[35].trim() === 'BANK_CHECK',
        validator: null,
        msg: 'Missing Mode of payment Check Number'
      },
      modeOfPaymentDebitAccountNumber: {
        isRequired: colData[35].trim() === 'DIRECT_DEBIT',
        validator: null,
        msg: 'Missing Mode of payment Debit Account Number'
      },
      bankPesoAccountNumber: {
        isRequired: true,
        validator: this.validateAccountNumber,
        msg: 'Invalid Bank Peso Account Number value'
      },
      settlementBankCode: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('settBankCode', value) },
        msg: 'Invalid Settle Bank Code value'
      },
      registrationOfSecurities: {
        isRequired: true,
        validator: (value) => { return this.validateListValue('registrationOfSecurities', value) },
        msg: 'Invalid value for Registration of Securities'
      },
      nameOfPDTCDepositoryParticipant: {
        isRequired: colData[41].trim() === 'PDTC_CORP',
        validator: null
      },
      applicantNoCDBPID: {
        isRequired: colData[41].trim() === 'PDTC_CORP',
        validator: this.validateApplicantNoCDBPID,
        msg: 'Invalid Applicant NOCD BPID - cannot end with B'
      },
      pdtcDepositoryParticipantBPID: {
        isRequired: colData[41].trim() === 'PDTC_CORP',
        validator: null
      },
      pdtcDepositoryParticipantOmnibusAccNum: {
        isRequired: colData[41].trim() === 'PDTC_CORP',
        validator: null
      },
      amountInFigures: {
        isRequired: colData[35].trim() === 'BANK_BONDS',
        validator: null,
        msg: 'Missing Amount In Figures'
      },
    }

    if(colData[35].trim() !== 'BANK_BONDS'){
      delete colFormat.amountInFigures;
    };

    var index = 0;
   
    for(var key in colFormat) {
      var fieldValue = colData[index];
      if(fieldValue.includes('"')){
        fieldValue = fieldValue.replaceAll('"','');
      }
      if(colFormat[key].isRequired) {
        if(fieldValue.trim() === ''){
          return {
            valid: false,
            msg: 'Required Value ' + key
          }
        }
        if(colFormat[key].validator !== null) {
          var result = colFormat[key].validator(fieldValue);
          if(typeof(result) === 'string'){
            return {
              valid: false,
              msg: result
            }
          }
          if(!result){
            return {
              valid: false,
              msg: colFormat[key]['msg'] + '. Field Value: ' + fieldValue
            }
          }
        }
      } else {
        if(fieldValue.trim() !== ''){
          if(colFormat[key].validator !== null){
            var result = colFormat[key].validator(fieldValue);
            if(typeof(result) === 'string'){
              return {
                valid: false,
                msg: result
              }
            }
            if(!result){
              return {
                valid: false,
                msg: colFormat[key]['msg'] + '. Field Value: ' + fieldValue
              }
            }
          }
        }
      }
      index+=1;
    }
    return {
      valid: true,
      msg: 'OK'
    }
  }
}